import { UserProfile } from '../types/database';

export function profileDisplayName(
  profile: Pick<UserProfile, 'first_name' | 'last_name' | 'full_name'> | null | undefined
): string {
  const first = profile?.first_name?.trim();
  const last = profile?.last_name?.trim();
  if (first && last) return `${first} ${last}`;
  if (first) return first;
  const full = profile?.full_name?.trim();
  if (full) return full;
  return 'Parent';
}

export function buildFullName(firstName?: string | null, lastName?: string | null): string | null {
  const value = [firstName?.trim(), lastName?.trim()].filter(Boolean).join(' ');
  return value || null;
}
